import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { ensure4LetterIsoLanguage } from "@ankaadia/ankaadia-shared";
import { Consent } from "@ankaadia/graphql";
import { TranslocoService } from "@jsverse/transloco";
import { TabView as OldTabView } from "primeng-v17/tabview";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "primeng/tabs";
import { SafePipe } from "../../../../shared/pipes/safe.pipe";
import { TranslateDirective } from "../../../../shared/transloco/translate.directive";

@Component({
  selector: "new-ui-tc-consent-view",
  templateUrl: "./new-ui-tc-consent-view.component.html",
  imports: [TranslateDirective, SafePipe, TabPanels, TabPanel, TabList, Tab, Tabs],
})
export class NewUiTcConsentViewComponent {
  readonly ensure4LetterIsoLanguage = ensure4LetterIsoLanguage;

  activeIndex: number;

  @Input()
  set initalIndex(index: number) {
    this.activeIndex = index;
  }

  @Output()
  readonly tabChanged = new EventEmitter<{ language: string; tabIndex: number }>();

  @Input()
  consents: Pick<Consent, "language" | "contents">[];

  @Input()
  viewLanguage: string = this.transloco.getActiveLang();

  @Input()
  dialogMode: boolean;

  @ViewChild("tabs")
  tab: OldTabView;

  constructor(private readonly transloco: TranslocoService) {}

  onTabChanged(): void {
    this.tabChanged.emit({ language: this.consents[this.activeIndex].language, tabIndex: this.activeIndex });
  }
}
